import { View } from "extensions/marionette";
import webix from "extensions/webix";
import { escape } from "lodash-es";

import { store } from "common/store";
import { nextTick } from "common/utils";

export const BusinessUnitTree = View.extend({
    name: "Business unit picker",
    template: () => "<div><div id='buTree'></div></div>",
    
    initialize() {
        this.treeData = this.convertCollection();
    },
    
    convertCollection() {
        const selectedId = store.getState().common.bu_ref || store.getState().common.merchant_ref;
        const topLevel = [];
        const convertChildren = (node) => {
            const data = [];
            node.children.forEach((n) => data.push(convertNode(n)));
            return data;
        };
        const convertNode = (node) => {
            const id = node.get("id");
            return {
                id,
                value: node.get("display_name"),
                open: false,
                data: convertChildren(node),
                $css: id === selectedId ? "selected" : ""
            };
        };
        this.collection.models.forEach((n) => topLevel.push(convertNode(n)));
        return topLevel;
    },
    onAttach() {
        // TODO - WHY DOESN"T THIS FIRE??????  Because DOM not visible?
    },
    onRender() {
        setTimeout(() => {
            if (this.isRendered()) {
                this.renderBUTree();
            }
        }, 200);
    },
    onBeforeDestroy() {
        this.killTree();
    },
    killTree() {
        if (this.webixTree) {
            this.webixTree.destructor();
        }
    },
    expandUpFromSelectedNode() {
        const selectedId = store.getState().common.bu_ref || store.getState().common.merchant_ref;
        const node = this.webixTree.getItem(selectedId);
        if (node) {
            const expandId = node.$count === 0 ? node.$parent : selectedId;
            this.webixTree.open(expandId, true);
        }
    },
    renderBUTree(startOnNode) {
        const self = this;
        this.killTree();
        
        const tree = webix.ui({
            view: "tree",
            select: true,
            container: "buTree",
            width: 700,
            data: this.treeData,
            
            template(obj, common) {
                return `${common.icon(obj, common)}<span>${escape(obj.value)}</span>`;
            },
            
            on: {
                onItemClick(id, e, trg) {
                    e.stopPropagation();
                    e.preventDefault();
                    if (e.srcElement === "path") {
                        const node = this.getItem(id);
                        if (node.open) {
                            this.close(id);
                        } else {
                            this.open(id);
                        }
                    } else {
                        nextTick(() => self.triggerMethod("change:bu", id), 0);
                    }
                }
            },
    
            type: {
                icon(obj) {
                    const actionClass = obj.open ? "tree_icon webix_tree_open fal fa-minus-square" : "tree_icon webix_tree_close fal fa-plus-square";
                    const actionIconClass = obj.$count === 0 ? "tree_icon" : actionClass;
                    if (obj.$css === "selected") {
                        return `<span class="${actionIconClass} fas fa-check-circle"></span>`;
                    }
                    // eslint-disable-next-line sentence-case/sentence-case
                    if (obj.value === "Unmapped MIDs") {
                        return `<span class="${actionIconClass} fas fa-question-circle"></span>`;
                    }
                    return `<span class="${actionIconClass}"></span>`;
                }
                
            }
    
        });
        webix.extend(tree.on_click, {
            webix_tree_open(e, id) {
                this.close(id);
                e.stopPropagation();
                e.preventDefault();
                return false;
            },
            webix_tree_close(e, id) {
                this.open(id);
                e.stopPropagation();
                e.preventDefault();
                return false;
            },
            webix_tree_checkbox(e, id) {
                this._tree_check_uncheck(id, null, e);
                return false;
            }
        }, true);
        
        this.webixTree = tree;
        this.expandUpFromSelectedNode();
    }
});
